/**
 * provide access to the fullscreen mapbox-gl map
 * this.mapPromise is available to queue things for when the map loads
 * this.map is available once the map has loaded, otherwise it's null
 * synchronously check if the map has loaded with (map !== null)
 * in an async method, you can use: const map = await this.mapPromise;
 */
export default {
    data() {
        return {
            map: null,
        };
    },
    computed: {
        mapPromise() {
            return this.$store.state.mapPromise;
        },
    },
    async created() {
        // set this.map when the map is loaded
        this.map = await this.mapPromise;
    },
};



// WEBPACK FOOTER //
// ./src/mixins/map.js